import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'es',
  lng: 'es',
  resources: {
    en: {
      translations: require('./locales/en/locale.json')
    },
    es: {
      translations: require('./locales/es/locale.json')
    },
    br: {
      translations: require('./locales/br/locale.json')
    },
    zh: {
      translations: require('./locales/zh/locale.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['es', 'en', 'br', 'zh'];

export default i18n;